import { ClassValue } from 'clsx';

import DropdownActionItem, {
  IDropdownActionItemProps,
} from './DropdownActionItem';
import { DropdownMenu } from './DropdownMenu';

interface IDropdownActionsProps {
  children: React.ReactNode;
  className?: ClassValue;
  options: IDropdownActionItemProps[];
  title?: string;
}

export default function DropdownActions({
  children,
  className,
  options,
  title,
}: IDropdownActionsProps) {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger className={className}>
        {children}
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        side="right"
        sideOffset={4}
        align="start"
        alignOffset={4}
      >
        {title && <p className="text-grey-500 text-sm"> {title} </p>}
        {options.map((option) => (
          <DropdownActionItem
            key={option.description}
            description={option.description}
            icon={option.icon}
            disabled={option.disabled}
            className={option.className}
            danger={option.danger}
            onClick={option.onClick}
            selected={option.selected}
          />
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
